var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section-view',{attrs:{"title":_vm.title,"tips":_vm.tips}},[_c('div',{ref:"chart",class:['chart', {multiple: this.list.length > 3 || this.list.length === 0}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }